import { combineTokens } from '@utils/css';

const tokens = combineTokens("--text-input", {
  x: 0,
  y: 0,
  scale: 1
});
const wrapper = "_35swqlqe2j";

export { tokens, wrapper };
import "./input.text.style.linaria.module.css";
//# sourceMappingURL=input.text.style.js.map
